import { render, staticRenderFns } from "./ButcherRewards.vue?vue&type=template&id=070deea0&"
import script from "./ButcherRewards.vue?vue&type=script&lang=js&"
export * from "./ButcherRewards.vue?vue&type=script&lang=js&"
import style0 from "./ButcherRewards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports